import { createWizardContext } from '@/modules/common/components/wizard';
import { FormState, PageKeys } from './types';

export const invoiceDraftWizardContext = createWizardContext<
  FormState,
  PageKeys
>();
